<template>
  <section>
    <div class="row my-4">
      <div class="col-md-12">
        <div class="my-4">
          {{ text }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    data () {
      return {
        text: ''
      }
    },
    created () {
      let queryParams = this.$route.query
      console.log('DEBUG', queryParams)
      this.$http.get('line/login', { params: queryParams })
        .then(response => {
          return response.json()
        })
        .then(response => {
          console.log('DEBUG', response)
          if (response.error) {
            this.text = 'การเชื่อมต่อไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่ค่ะ'
          } else {
            this.text = 'สำเร็จ'
          }
        }).catch(error => {
          console.log('DEBUG', error)
          this.text = 'การเชื่อมต่อไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่ค่ะ'
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/LineLoginCallback.vue